module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 15.12.22@2x.543cb774.png";